import React, { useEffect } from 'react';

export interface Metadata {
    title: string;
}

export type MetadataHandler = (metadata: Metadata) => void;

export function useHandleMetadata(metadata: Metadata, handleMetadata?: MetadataHandler) {
    const handledRef = React.useRef(false);

    useEffect(() => {
        if (handledRef.current || !handleMetadata) {
            return;
        }

        handleMetadata(metadata);
        handledRef.current = true;
    }, [metadata, handleMetadata]);
}
